import { Link } from '@/lib/router-compat';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Package, Monitor, Database, ArrowRight } from 'lucide-react';

const ProductsOverview = () => {
  const productHighlights = [
    {
      icon: Package,
      title: 'Software',
      description: 'The Agentic Enterprise Platform, custom agentic software, and decision support built around your workflows, data, and integrations.',
      link: '/products/software'
    },
    {
      icon: Monitor,
      title: 'Hardware',
      description: 'End-user computing, networking, displays, and workplace technology tailored to your organization.',
      link: '/products/hardware'
    },
    {
      icon: Database,
      title: 'Compute',
      description: 'AI and GPU infrastructure, high-performance computing, enterprise systems, and edge compute for demanding workloads.',
      link: '/products/compute'
    }
  ];

  return (
    <section id="products" className="section-padding bg-background border-t border-border/50">      
      <div className="container-max">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight text-primary">
            Our Products
          </h2>
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-semibold mb-4 text-foreground">
              Innovation<span className="text-primary">.</span> Productivity<span className="text-primary">.</span> Performance<span className="text-primary">.</span>
            </h3>
            <p className="text-lg text-muted-foreground">
              Our <strong>enterprise AI platform</strong>, <strong>custom software</strong>, and <strong>technology products</strong> are engineered to solve complex challenges and accelerate mission success.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10 mb-16">
          {productHighlights.map((product, index) => (
            <Card 
              key={product.title} 
              className="border-border/50 bg-card/50 transition-colors duration-300 flex flex-col h-full min-w-0"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardHeader className="pb-4 flex-shrink-0">
                <product.icon className="h-7 w-7 text-primary mb-4" />
                <CardTitle className="text-xl font-semibold text-foreground leading-tight">
                  {product.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-0 flex flex-col flex-grow">
                <p className="text-muted-foreground">
                  {product.description}
                </p>
                <div className="mt-auto pt-6">
                  <Button asChild variant="outline" className="w-full">
                    <Link to={product.link}>Explore {product.title}<ArrowRight className="ml-2 h-4 w-4" /></Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Button asChild className="btn-hero group">
            <Link to="/products" className="flex items-center">
              View All Products
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProductsOverview;
